import axios from 'axios'
import qs from 'qs'

export const leapsAffirmationService = ({
  getLeapsAffirmationList (token) {
    return axios.get('/api/leaps/Affirmation', {headers: {'Authorization': 'Bearer ' + token}})
  },
  createLeapsAffirmation (token, leapsAffirmationObj) {
    var stringifiedObj = qs.stringify(leapsAffirmationObj)
    return axios.post('/api/leaps/Affirmation', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateLeapsAffirmation (token, leapsAffirmationObj) {
    var stringifiedObj = qs.stringify(leapsAffirmationObj)
    return axios.put('/api/leaps/Affirmation', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteLeapsAffirmation (token, affirmationId) {
    return axios.delete('/api/leaps/Affirmation?AffirmationID=' + affirmationId, {headers: {'Authorization': 'Bearer ' + token}})
  }
})



// WEBPACK FOOTER //
// ./src/server-util/leaps-affirmation-service.js